import { useEffect, useState } from 'react';

import { trpc } from '../../config/trpc';
import { useAuth } from '../../context/AuthProvider';

export const useSetWatchingRequest = (requestId: number) => {
  const { user } = useAuth();

  // Doesn't really control enabling, it will get flipped to true when set to false to reinstate the connection
  const [isEnabled, setIsEnabled] = useState(true);

  // Utilizing subscriptions, we can easily track when a disconnect occurs.
  // This simply gives our info at the beginning of the connection, and sustains it. Once it dies, we can assume the user left
  trpc.watchingRequest.useSubscription(
    {
      page: requestId,
      name: user?.full_name,
    },
    {
      onData() {},
      enabled: !!user && isEnabled,
    },
  );

  // Here's some fun!
  // Status icons decay after 5 minutes, so we need to refresh it if actions are taken.
  // Since it tracks via a subscription, a little bit of weirdness is needed. We toggle the `enabled`
  // state on and off briefly to reconnect it

  useEffect(() => {
    // Since redraws don't take place immediately, there's enough time for it to do the reconnect
    if (!isEnabled) {
      setIsEnabled(true);
    }
  }, [isEnabled]);

  // We just globally detect clicks.
  useEffect(() => {
    // This only ensures that it triggers after 1 minute. Precise? No. But it gets the job done.
    let wait = Date.now() + 60 * 1000;
    const refresh = () => {
      if (Date.now() > wait) {
        setIsEnabled(false);
        wait = Date.now() + 60 * 1000;
      }
    };
    window.addEventListener('click', refresh);

    return () => {
      window.removeEventListener('click', refresh);
    };
  }, [setIsEnabled]);
};
